import { Component, OnInit } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { FeatherModule } from 'angular-feather';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SharedModule } from 'src/app/shared/shared.module';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  selector: 'app-index-real-estate',
  templateUrl: './index-real-estate.component.html',
  styleUrls: ['./index-real-estate.component.css'],
  standalone:true,
  imports:[SharedModule, FeatherModule, ScrollToModule, SlickCarouselModule, CarouselModule,NgbModule ]
})

/***
 * Real Estate Component
 */
export class IndexRealEstateComponent implements OnInit {

  // Set Topbar Option
  Menuoption = 'job';
  Settingicon = false;
  navClass = 'nav-light';


  public config = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false
  };

  /***
   * Testimonial Slider
   */
  customOptions: OwlOptions = {
    // loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    autoplay: true,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      900: {
        items: 2
      },
      1024: {
        items:2
      }
    },
    nav: false,
  };

  /**
   * Review Testimonial Data
   */
  reviewData = [
    {
      profile: "assets/images/client/01.jpg",
      name: "Thomas Israel ",
      designation: "C.E.O",
      message: `" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century. "`
    },
    {
      profile: "assets/images/client/02.jpg",
      name: "Carl Oliver",
      designation: "P.A",
      message: `" The advantage of its Latin origin and the relative meaninglessness
      of Lorum Ipsum is that the text does not attract attention to itself or distract the viewer's attention
      from the layout. "`
    },
    {
      profile: "assets/images/client/03.jpg",
      name: "Barbara McIntosh",
      designation: "M.D",
      message: `" There is now an abundance of readable dummy texts. These are
      usually used when a text is required purely to fill a space. These alternatives to the classic Lorem
      Ipsum texts are often amusing and tell short, funny or nonsensical stories. "`
    },
    {
      profile: "assets/images/client/04.jpg",
      name: "Christa Smith",
      designation: "Manager",
      message: `" According to most sources, Lorum Ipsum can be traced back to a text
      composed by Cicero in 45 BC. Allegedly, a Latin scholar established the origin of the text by compiling
      all the instances of the unusual word 'consectetur' he could find "`
    },
    {
      profile: "assets/images/client/05.jpg",
      name: "Dean Tolle",
      designation: "Developer",
      message: `" It seems that only fragments of the original text remain in the
      Lorem Ipsum texts used today. The most well-known dummy text is the 'Lorem Ipsum', which is said to have
      originated in the 16th century. "`
    },
    {
      profile: "assets/images/client/06.jpg",
      name: "Jill Webb",
      designation: "Designer",
      message: `" It seems that only fragments of the original text remain in the
      Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added
      or deleted at various positions within the text. "`
    }
  ];

  /**
   * Blog Data
   */
  blogData = [
    {
      image: "assets/images/real/p1.jpg",
      title: "Design your apps in your own way",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    },
    {
      image: "assets/images/real/p2.jpg",
      title: "How apps is changing the IT world",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    },
    {
      image: "assets/images/real/p3.jpg",
      title: "Smartest Applications for Business",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    }
  ];

  yearlyData = [
    {
      title: "Plan Real Estate",
      price: 10,
      current: "$us",
      date: 'Anual',
      list: ["Mensual - 500$us - 3000$us / Cliente", "Anual - +2 meses gratis"],
      btn: "Comprar ahora"
    },
    {
      warning: "Mejor plan",
      title: "Plan Implementación",
      price: 139,
      current: "Bs",
      date: 'Anual',
      list: ["Estándar - 800$us - 1500$us / Producto", "Desarrollo a medida - Desde 1000$us en adelante",],
      btn: "Comprar ahora"
    },
  ];


  constructor(
    private gtmService: GoogleTagManagerService
  ) { }

  ngOnInit(): void {
    this.sendPageLoadEvent();
  }

  trackEvent() {
    const dataLayer = {
      event: 'Boton contactar real state',
      category: 'Button',
      action: 'Click',
      label: 'Track Button Click'
    };
    this.gtmService.pushTag(dataLayer); 
  }

  sendPageLoadEvent() {
    const dataLayer = {
      event: 'page_load', 
      page: window.location.pathname  
    };
    this.gtmService.pushTag(dataLayer);
  }

}
